import { ToggleInput, ToggleSize, NotificationTemplateTypes } from '@ui/src';
import { RowWithToggleProps } from './types';

import cn from './notification-settings.module.css';

const RowWithToggle = ({
  onChange,
  onSelectRow,
  isSelectedRow,
  id,
  isCheckedToggle,
  item,
  isEditable,
  disabled,
}: RowWithToggleProps): React.JSX.Element => (
  <div
    className={`${onSelectRow ? cn.columnRow : cn.permissionColumnRow} ${
      isSelectedRow ? cn.columnRowActive : ''
    }`}
  >
    {onSelectRow && (
      <button
        onClick={() => onSelectRow(id as NotificationTemplateTypes)}
        className={`${cn.columnRowLink} ${
          isSelectedRow ? cn.columnRowLinkActive : ''
        }`}
        aria-label="select row"
        type="button"
      />
    )}

    <div
      className={
        onSelectRow ? cn.switchColumnRowWrapper : cn.permissionColumnRowWrapper
      }
    >
      <div className={cn.switchColumnRowTitle}>{item.title}</div>
      <ToggleInput
        className={cn.toggleWrapper}
        size={ToggleSize.MEDIUM}
        name={
          // @ts-ignore
          NotificationTemplateTypes[id as NotificationTemplateTypes]
            ? // @ts-ignore
              NotificationTemplateTypes[id as NotificationTemplateTypes]
            : id
        }
        checked={isCheckedToggle}
        onChange={(e) =>
          onChange(id as NotificationTemplateTypes, e.target.checked, item)
        }
        disabled={!isEditable || disabled}
      />
    </div>
    {item.description && (
      <div
        className={cn.switchColumnRowDescription}
      >{`in ${item.description}`}</div>
    )}
  </div>
);

export default RowWithToggle;
